export default "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYjc1MzRjNWMyYzliNDA2NTY5YzgzZGM0MjkzMTc3YjAucG5nIjs="